import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { t } = useLang();
  const { user, login, bootstrapped } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (bootstrapped && user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || t("admin.invalid"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen flex items-center justify-center px-6 bg-bg">
      <div className="w-full max-w-md">
        <div className="font-display text-3xl text-ink text-center mb-2">C—Carpenter</div>
        <p className="text-eyebrow text-brand text-center mb-12">{t("admin.login")}</p>
        <form
          onSubmit={onSubmit}
          className="bg-bg-surface border border-edge p-8 space-y-5"
          data-testid="admin-login-form"
        >
          <div>
            <label className="text-eyebrow text-ink-muted block mb-2">{t("admin.email")}</label>
            <input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border border-edge px-4 py-3 text-ink focus:outline-none focus:border-brand transition-colors"
            />
          </div>
          <div>
            <label className="text-eyebrow text-ink-muted block mb-2">{t("admin.password")}</label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border border-edge px-4 py-3 text-ink focus:outline-none focus:border-brand transition-colors"
            />
          </div>
          {err && (
            <p data-testid="admin-login-error" className="text-sm text-bad">
              {err}
            </p>
          )}
          <button
            data-testid="admin-login-submit"
            disabled={busy}
            type="submit"
            className="w-full py-4 bg-brand text-ink-inverse text-sm font-medium tracking-wide hover:bg-brand-hover transition-colors disabled:opacity-60"
          >
            {busy ? "…" : t("admin.signIn")}
          </button>
        </form>
      </div>
    </div>
  );
}
